<div class="grid">
  <div class="sm:col-12 md:col-6 lg:col-6 xl:col-5 m-auto pt-8 mt-6">
    <div class="card mb-4">
      <div class="surface-card p-2 md:p-8 md:shadow-2 border-round w-full mt-4">

        <!-- EN / FR language toggle -->
         <div class="flex justify-content-end mb-2">
          <div class="lang-toggle flex gap-1">
            <button
              type="button"
              pButton
              label="EN"
              size="small"
              [outlined]="currentLang() !== 'en'"
              [severity]="currentLang() === 'en' ? 'primary' : 'secondary'"
              (click)="setLanguage('en')">
            </button>
            <button
              type="button"
              pButton
              label="FR"
              size="small"
              [outlined]="currentLang() !== 'fr'"
              [severity]="currentLang() === 'fr' ? 'primary' : 'secondary'"
              (click)="setLanguage('fr')">
            </button>
          </div>
        </div>

        <div class="text-center mb-8">
          <div class="inline-block bg-primary mb-8 p-2">
            <img src="/assets/img/tlogo4.svg" alt="Image" width="205" height="51">
          </div>
          <div class="text-600 text-2xl font-medium line-height-3">{{ 'WELCOME.SUBTITLE' | translate }}</div>
          <div class="mt-4 text-center">
            <span class="text-600 font-medium line-height-3">{{ 'WELCOME.PROMPT' | translate }}</span>
          </div>
          <div class="flex mt-4 gap-3 justify-content-center">
            <p-button
              [label]="'WELCOME.BTN_PRO' | translate"
              [style]="{ 'font-size': '0.9rem' }"
              pRipple
              icon="pi pi-user"
              [routerLink]="currentLang() === 'fr' ? '/fr/login/pro' : '/login/pro'"
              severity="primary" />
            <p-button
              [label]="'WELCOME.BTN_LEARNING' | translate"
              pRipple
              icon="pi pi-user"
              routerLink="/login/learning"
              severity="primary" />
            <p-button
              [label]="'WELCOME.BTN_EXAM' | translate"
              pRipple
              icon="pi pi-user"
              routerLink="/login/exam"
              severity="primary" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
